import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useSyncEngine, type SyncContextValue } from './useSyncEngine';

const SyncContext = createContext<SyncContextValue | null>(null);

export function SyncProvider({ children }: { children: ReactNode }) {
  const value = useSyncEngine();
  const memoized = useMemo(() => value, [value]);
  return <SyncContext.Provider value={memoized}>{children}</SyncContext.Provider>;
}

export function useSync(): SyncContextValue {
  const context = useContext(SyncContext);
  if (!context) throw new Error('useSync debe usarse dentro de SyncProvider');
  return context;
}
